import { Config } from 'modules/config/state/config-types'
import { StripePaymentRequest } from './stripe-payment-request-types'

export const makeStripePaymentRequestInitialState = (config: Config): StripePaymentRequest => {
  const isDWEnabled = config.payment.activeMethods.some((method) => method.type === 'DW')
  const walletType = detectWalletType()

  return isDWEnabled && walletType
    ? { walletType, canMakePayment: true }
    : { walletType: null, canMakePayment: false }
}

export function detectWalletType(): StripePaymentRequest['walletType'] {
  if (typeof window === 'undefined') return null // SSR safety

  // Mimic Stripe's Payment Request API detection logic
  // This follows the same pattern as Stripe's canMakePayment() method

  // Check for Apple Pay support
  // Apple Pay requires ApplePaySession API and specific browser/device combinations
  const hasApplePaySupport = () => {
    if (!('ApplePaySession' in window)) return false

    // Apple Pay is supported on:
    // - Safari on macOS/iOS
    // - Chrome 67+ on macOS
    // - Other browsers that implement ApplePaySession on Apple devices
    const ua = navigator.userAgent.toLowerCase()
    const isAppleDevice = /iphone|ipad|ipod|macintosh/.test(ua)

    return isAppleDevice
  }

  // Check for Google Pay support
  // Google Pay requires PaymentRequest API and supported browsers
  // Works on Chrome, Firefox, Safari, Edge, Opera on any platform
  const hasGooglePaySupport = () => {
    if (!('PaymentRequest' in window)) return false

    const ua = navigator.userAgent.toLowerCase()
    const isChrome = /chrome/.test(ua) && navigator.vendor?.toLowerCase().includes('google')
    const isFirefox = /firefox/.test(ua)
    const isSafari = /safari/.test(ua) && !isChrome // Safari but not Chrome
    const isEdge = /edg/.test(ua) // Edge uses "Edg" in user agent
    const isOpera = /opr/.test(ua) || /opera/.test(ua)

    return isChrome || isFirefox || isSafari || isEdge || isOpera
  }

  // Priority: Apple Pay takes precedence over Google Pay
  // This matches Stripe's behavior where applePay is checked first
  if (hasApplePaySupport()) {
    return 'APPLEPAY'
  }

  if (hasGooglePaySupport()) {
    return 'GPAY'
  }

  return null
}
